import React, { useState } from 'react';
import { FileDownIcon, MenuIcon, ClipboardIcon, BarChart2Icon, LayersIcon, LightbulbIcon, BoxIcon, FlameIcon, Loader2Icon } from 'lucide-react';
import { MobileNav } from './MobileNav';
import { exportReportToPdf } from '../utils/exportPdf';
interface HeaderProps {
  timeRange: string;
  setTimeRange: (range: string) => void;
}
export const Header: React.FC<HeaderProps> = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('overview');
  const [isExporting, setIsExporting] = useState(false);
  const navItems = [{
    id: 'overview',
    label: 'Context',
    icon: ClipboardIcon,
    section: 'overview',
    href: '#overview'
  }, {
    id: 'heatmap',
    label: 'Heatmap',
    icon: FlameIcon,
    section: 'heatmap',
    href: '#heatmap'
  }, {
    id: 'analysis',
    label: 'Driver Analysis',
    icon: LayersIcon,
    section: 'analysis',
    href: '#analysis'
  }, {
    id: 'dynamics',
    label: 'System Dynamics',
    icon: BoxIcon,
    section: 'dynamics',
    href: '#dynamics'
  }, {
    id: 'assessment',
    label: 'Assessment',
    icon: BarChart2Icon,
    section: 'assessment',
    href: '#assessment'
  }, {
    id: 'recommendations',
    label: 'Takeaways',
    icon: LightbulbIcon,
    section: 'recommendations',
    href: '#recommendations'
  }];
  const handleExport = async () => {
    if (isExporting) return;
    setIsExporting(true);
    try {
      await exportReportToPdf('ooh-attention-report.pdf');
    } finally {
      setIsExporting(false);
    }
  };
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80; // Adjust this value based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setActiveItem(sectionId);
  };
  return <header className="bg-white border-b border-gray-100 sticky top-0 z-50" data-id="element-238" data-mp="1hnru3lmhlcxw">
      <div className="container mx-auto px-4" data-id="element-239" data-mp="1hlnp10cuq7w1">
        <div className="flex items-center justify-between h-16" data-id="element-240" data-mp="1mm301l9nv3au">
          <div className="flex items-center" data-id="element-241" data-mp="18n3bseq28qf7">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/caJJCtS3envvP8mN4NRUHS/Brandpulse_logo.png" alt="BrandPulse" className="h-6 w-auto" data-id="element-242" data-mp="18madm256398o" />
          </div>
          <nav className="hidden md:flex items-center space-x-1" data-export-hide data-id="element-243" data-mp="yqqivj2cagli">
            {navItems.map(item => {
            const Icon = item.icon;
            return <a key={item.id} href={item.href} onClick={e => {
              e.preventDefault();
              scrollToSection(item.section);
            }} className={`flex items-center px-3 py-1.5 rounded-full text-sm transition-colors ${activeItem === item.section ? 'bg-[#1E90FF]/5 text-[#1E90FF]' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-244" data-mp="2t13vlpurxjgw">
                  <Icon className="h-4 w-4 mr-2" data-id="element-245" data-mp="rczg5h4b5s4p" />
                  {item.label}
                </a>;
          })}
          </nav>
          <div className="flex items-center space-x-2" data-export-hide data-id="element-246" data-mp="156z5ap5jqvfb">
            <button onClick={handleExport} disabled={isExporting} aria-busy={isExporting} className="hidden md:flex items-center space-x-2 bg-white border border-[#1E90FF] text-[#1E90FF] px-4 py-2 rounded-lg font-medium hover:bg-[#1E90FF]/5 transition-colors disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-247" data-mp="105tamlsbsy35">
              {isExporting ? <>
                  <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-248" data-mp="22ynmxqh8x3ge" />
                  <span data-id="element-249" data-mp="22yfafzp1c05q">Preparing…</span>
                </> : <>
                  <FileDownIcon className="h-4 w-4" data-id="element-250" data-mp="27vxat1ozl724" />
                  <span data-id="element-251" data-mp="2cwbgid3484wz">Export PDF</span>
                </>}
            </button>
            <a href="https://create.brandpulse-analytics.com/" target="_blank" rel="noopener noreferrer" className="hidden md:block bg-[#1E90FF] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#1E90FF]/90 transition-colors whitespace-nowrap" data-id="element-252" data-mp="2gyye6umgwk23">
              Create new
            </a>
            <button onClick={() => setIsMobileNavOpen(true)} className="md:hidden p-2 hover:bg-gray-50 rounded-full" data-id="element-253" data-mp="1t6rdxkdmfsxe">
              <MenuIcon className="h-5 w-5 text-gray-600" data-id="element-254" data-mp="11gmxtxww9s1z" />
            </button>
          </div>
        </div>
      </div>
      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} navItems={navItems} activeItem={activeItem} setActiveItem={id => {
      setActiveItem(id);
      scrollToSection(id);
    }} data-id="element-255" data-mp="15hqcih37hi1m" />
    </header>;
};